import React from 'react';
import SeenByAvatarChip from './SeenByAvatarChip';

function SeenByAvatars({ seenByUsers, onPress, pressableAriaLabel }) {
  if (!seenByUsers?.length) {
    return null;
  }

  const shown = seenByUsers.slice(0, 3);
  const rest = seenByUsers.length - 3;

  const content = (
    <div className="flex flex-wrap items-center gap-2 normal-case mt-2 mb-1 pointer-events-none">
      <span className="text-xs text-black/50">Seen by:</span>
      <div className="flex -space-x-2 items-center">
        {shown.map(user => (
          <SeenByAvatarChip key={user.id} user={user} sizeClass="w-7 h-7" showRing />
        ))}
      </div>
      {rest > 0 && <span className="text-xs text-black/50">+{rest} more</span>}
    </div>
  );

  if (!onPress) {
    return content;
  }

  return (
    <div className="relative">
      {content}
      <button
        type="button"
        className="absolute inset-0 min-h-[32px] w-full cursor-pointer bg-transparent border-0 p-0"
        aria-label={pressableAriaLabel || 'Seen by'}
        onClick={onPress}
      />
    </div>
  );
}

export default SeenByAvatars;
